import { createFileRoute } from "@tanstack/react-router";

import ProfileRoute from "./-components/ProfileRoute";

export const Route = createFileRoute("/_app/_dashboard/profile/")({
  component: ProfileRoute,
});
